import FirebaseService from "./FirebaseService";
import { BaseServiceError } from "./BaseServiceError";

export default class AuthService extends FirebaseService {
  async logout() {
    try {
      await this.auth.signOut();
    } catch (error) {
      console.error("AuthService.signOut", error);
      throw new AuthServiceError("COULD_NOT_SIGN_OUT", error);
    }
  }
}

export type AuthServiceErrorCode =
  | "COULD_NOT_SIGN_IN_WITH_GOOGLE"
  | "COULD_NOT_SIGN_IN_WITH_SAML"
  | "COULD_NOT_SIGN_OUT";

export class AuthServiceError extends BaseServiceError<AuthServiceErrorCode> {
  mapErrorCodeToMessage(Code: AuthServiceErrorCode): string {
    switch (Code) {
      case "COULD_NOT_SIGN_IN_WITH_GOOGLE":
        return "Could not sign in with Yac Google Account.";
      case "COULD_NOT_SIGN_IN_WITH_SAML":
        return "Could not sign in with SSO.";
      case "COULD_NOT_SIGN_OUT":
        return "Could not sign out.";
      default:
        return "There has been an unknown error.";
    }
  }
}
